import React from 'react'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import {
  FormCheckboxInterface,
  FormSubentityTypeEnum,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { useUpdateFormSubentityProp } from '../../hooks/use-update-form-subentity-prop'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { FormSubentityCommonSettingsButtonLink } from './form-subentity-common-settings-button-link'
import { SidebarBottomPortal } from 'src/editor/layout/sidebar/settings/sidebar-bottom-portal'

export const FormCheckboxSubentitySettings = ({
  formEntity,
  checkboxSubentity,
}: {
  formEntity: FormInterface
  checkboxSubentity: FormCheckboxInterface
}) => {
  const updateProp = useUpdateFormSubentityProp(formEntity, checkboxSubentity)

  return (
    <>
      <TextInputControl
        update={updateProp('errorText')}
        value={checkboxSubentity.errorText}
        wrapperProps={{
          labelText: 'settings_options.checkbox_message',
        }}
        disabled={checkboxSubentity.optional}
      />
      <CheckboxControl
        label="entity_settings.explicit_consent.optional"
        tooltipText="entity_settings.explicit_consent.optional_popover"
        value={checkboxSubentity.optional}
        update={updateProp('optional')}
      />

      <GroupTitle></GroupTitle>

      <ColorPickerControl
        update={updateProp('color')}
        mobileUpdate={updateProp('mobileColor')}
        color={checkboxSubentity.color}
        mobileColor={checkboxSubentity.mobileColor}
        label="text color"
      />
      <HtmlAttrId attrId={checkboxSubentity.htmlAttrId} />

      <SidebarBottomPortal>
        <FormSubentityCommonSettingsButtonLink
          formEntity={formEntity}
          commonSettingsType={FormSubentityTypeEnum.Checkbox}
        />
      </SidebarBottomPortal>
    </>
  )
}
